import ServerError from 'errors/ServerError';
import { useGetCustomService } from './useGetCustomService';

export const useGetStrategyAllocations = () => {
    const result = useGetCustomService({
        service: 'customAdvisoryServices',
        api: 'getStrategyAllocations',
        enabled: true,
        gcTime: 10 * 60 * 1000,
        staleTime: 2 * 60 * 1000,

    });

    return {
        refetch: result?.refetch,
        strategyAllocations: result?.data?.data?.otherAssetAllocations || null,
        statusCode: result?.data?.status,
        error: result.error ? new ServerError(result.error) : result.error,
    };
};
